import { AbstractSchedule } from "./AbstractSchedule";
export class MinuteSchedule extends AbstractSchedule {
    executeJob() {
        //this._store.dispatch(refreshBoard());
    }
}
